import React from "react";
import { formatCurrency } from "../../utils/formato";

/**
 * Monto en una celda.
 *
 * `null` se muestra como N/A y no como cero: en el esquema financiero significa
 * que ese aportante no usa ese tipo de aportación, que no es lo mismo que
 * aportar cero.
 */
export default function Moneda({ valor, className = "" }) {
  if (valor === null || valor === undefined) {
    return <span className={`moneda-na ${className}`.trim()}>N/A</span>;
  }

  const numero = Number(valor);

  if (!numero) {
    return <span className={`moneda-cero ${className}`.trim()}>—</span>;
  }

  return <span className={`moneda ${className}`.trim()}>{formatCurrency(numero)}</span>;
}
